import Seo from '../components/Seo.jsx'
import Container from '../components/Container.jsx'

export default function PrivacyPolicy() {
  return (
    <>
      <Seo
        title="Privacy Policy"
        description="Learn how Spectranox gathers, uses, and secures client data in compliance with international privacy practices."
        path="/privacy"
      />
      <main className="min-h-screen bg-[#020617] pt-32 pb-24 text-slate-100 antialiased">
        <Container className="max-w-4xl">
          <div className="border-b border-slate-800 pb-8">
            <span className="font-mono text-xs uppercase tracking-widest text-emerald-500">Legal Agreement</span>
            <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
              Privacy Policy
            </h1>
            <p className="mt-4 text-sm text-slate-400">Last updated: July 2, 2026</p>
          </div>

          <div className="prose prose-invert mt-12 space-y-8 text-slate-300">
            <section className="space-y-3">
              <h2 className="text-xl font-bold text-white">1. Information We Collect</h2>
              <p className="leading-relaxed">
                At Spectranox, we value your privacy. We collect information necessary to fulfill your design, development, and marketing requests, including:
              </p>
              <ul className="list-disc list-inside ml-4 space-y-1">
                <li><strong>Contact details:</strong> Name, business email address, company name, phone number, and budget criteria sent via our contact forms.</li>
                <li><strong>Technical Logs:</strong> IP address, device type, operating system version, and general telemetry records.</li>
                <li><strong>Project Assets:</strong> Files, credentials, credentials mapping, codebases, and databases provided to execute projects.</li>
              </ul>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-bold text-white">2. How We Store and Process Data</h2>
              <p className="leading-relaxed">
                Form data and inquiry messages are captured, processed, and securely stored in our backend databases (including MySQL database setups run in local staging and production web servers).
              </p>
              <p className="leading-relaxed">
                We implement robust security measures to prevent unauthorized data access, leakage, or tampering. Project credentials and keys are strictly encrypted or limited to team members assigned to your project.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-bold text-white">3. Cookies and Analytics</h2>
              <p className="leading-relaxed">
                We use cookies to analyze web traffic, remember browser sessions, and optimize user experience. Cookies help us measure page loading metrics and identify patterns of usage on our website.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-bold text-white">4. Third-Party Disclosures</h2>
              <p className="leading-relaxed">
                Spectranox does not sell, lease, or distribute customer leads or personal details to third-party advertisers. Information is only shared with trusted service providers who assist us in operating our portal, server networks, and communications under strict confidentiality agreements.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-bold text-white">5. Your Data Rights</h2>
              <p className="leading-relaxed">
                Depending on your location, you may have rights under data privacy laws to access, correct, port, or request deletion of the personal information stored in our systems. To submit a request, contact our privacy officer.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-bold text-white">6. Contact Information</h2>
              <p className="leading-relaxed">
                If you have questions about this privacy policy, please contact us at <strong className="text-white">privacy@spectranox.com</strong>.
              </p>
            </section>
          </div>
        </Container>
      </main>
    </>
  )
}
